
import { Component, Prop, Vue } from "vue-property-decorator";
import { IAppraiserData } from "@/models/Appraiser";

@Component
export default class AppraiserValuationCadastralRef extends Vue {
  @Prop({ type: Object, required: true })
  protected valuation!: IAppraiserData;
}
